import { render, staticRenderFns } from "./MergeGroupDetail.vue?vue&type=template&id=b1a9f9c2&scoped=true"
import script from "./MergeGroupDetail.vue?vue&type=script&lang=js"
export * from "./MergeGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./MergeGroupDetail.vue?vue&type=style&index=0&id=b1a9f9c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a9f9c2",
  null
  
)

export default component.exports